import React from 'react';
import { Redirect } from 'react-router-dom';

import Grid from '@mui/material/Grid';

// core components
import Card from '../md/components/Card/Card.jsx';
import CardBody from '../md/components/Card/CardBody.jsx';

import DA from '../store/ReduxAccess';

import CrmButton from '../components/CrmButton';

class ClearStoragePage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      toHome: false,
    };
  }

  componentDidMount() {
    this.setState({ toHome: false });
    this.clearStore();
  }

  clearStore() {
    // clear out the entire redux and local stores
    const includingLoginInfo = true;
    DA.clearStore(includingLoginInfo);
    this.setState({ toHome: true });
  }

  render() {
    if (this.state.toHome) {
      return <Redirect to="/" />;
    }

    return (
      <div>
        <Grid container justifyContent="center">
          <Grid item xs={12} sm={6} md={4}>
            <Card>
              <CardBody>
                <CrmButton onClick={() => this.clearStore()}>Clear Store</CrmButton>
              </CardBody>
            </Card>
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default ClearStoragePage;
